import Throttle from './throttle.js';

export default function Debounce(delay, atBegin, callback) {
	return callback === undefined ? Throttle(delay, atBegin, false) : Throttle(delay, callback, atBegin !== false);
};